import React from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';
import TableRow from '@material-ui/core/TableRow';
import TableHead from '@material-ui/core/TableHead';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import Typography from '@material-ui/core/Typography';
import Table from '@/modules/common/components/Table';
import TableContainer from '@/modules/common/components/TableContainer';

const Component = ({items, selectedOffer, onContextMenu}) => {
    const getClassName = (offer) => {
        let className = 'context-menu';
        if (selectedOffer) {
            if (selectedOffer.offer_name === offer.offer_name && selectedOffer.offer_id === offer.offer_id) {
                className += ' selected';
            }
        }
        return className;
    };

    return (
        <TableContainer>
            <Table>
                <TableHead><TableRow>
                    <TableCell className="offer_name">Название</TableCell>
                    <TableCell className="offer_id">ID</TableCell>
                </TableRow></TableHead>
                <TableBody>
                    {items.map((offer) => (
                        <TableRow key={offer.offer_id} className={getClassName(offer)}
                                  onContextMenu={onContextMenu(offer)}
                        >
                            <TableCell className="offer_name"><Typography noWrap={true}>
                                <Link to={`/offers/${offer.offer_name}/`}>{offer.offer_name}</Link>
                            </Typography></TableCell>
                            <TableCell className="offer_id">{offer.offer_id}</TableCell>
                        </TableRow>
                    ))}
                </TableBody>
            </Table>
        </TableContainer>
    );
};

Component.propTypes = {
    items: PropTypes.array,
    selectedOffer: PropTypes.object,
    onContextMenu: PropTypes.func.isRequired,
};

export default Component;
